export default __webpack_public_path__ + "static/media/nada.b8ec16d3.png";